import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import React from "react";
import DocumentsForm from "../../../common/form/document/DocumentsForm";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepDocuments from "../../../../../../hooks/useStepDocuments";
import { fileGroups } from "../../../../../../config/fileGroupConfig";
import { ApplicationType } from "@duosoftbg/nacid-components";
import {
  completeDocumentStep,
  setStepDocumentsEdited,
} from "../../../../../../store/redux/slice/Forms/libservAdditionalDocForm";

const LibservAdditionalDocStepDocuments = () => {
  const libservAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.LibservAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepDocuments(
    libservAdditionalDocForm,
    baseEndpointPaths.libservAdditionalDoc,
    completeDocumentStep,
    setStepDocumentsEdited,
  );

  useFormReset("LIBSERV_ADDITIONAL_DOCUMENTS", libservAdditionalDocForm.documentDetails, methods.reset);

  return (
    <DocumentsForm
      methods={methods}
      onSubmit={onSubmit}
      setDocumentsFormEdited={setStepDocumentsEdited}
      hasAttachmentForm={true}
      hasAttachmentType={true}
      applicationId={libservAdditionalDocForm.id}
      fileGroup={fileGroups.pdf}
      informingMessageCode={["m.seServices.applications.info"]}
      applicationType={ApplicationType.LIBRARY}
      applicationSubType={"LIBSERV_ADDITIONAL_DOCUMENTS"}
    />
  );
};
export default LibservAdditionalDocStepDocuments;
